import { createElement } from 'react';
import * as FaIcons from 'react-icons/fa';

function getIconComponent(classString) {
    if (!classString) return null;
    const parts = classString.trim().split(/\s+/);
    // style prefix (solid, regular, brands)
    let prefix = 'Fa';
    if (parts[0] === 'far') prefix = 'FaReg';
    else if (parts[0] === 'fab') prefix = 'Fa';

    const faName = parts.find(p => p.startsWith('fa-'));
    if (!faName) return null;

    // convert "fa-handshake" -> "Handshake"
    const pascal = faName
        .replace(/^fa-/, '')
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');

    return FaIcons[prefix + pascal] || null;
}

export default function DynamicIconMapping({ classString, size = 20, color, ...rest }) {
    const iconComponent = getIconComponent(classString);
    return iconComponent ? createElement(iconComponent, { size, color, ...rest }) : null;
}
